(ns teamoesterreich.admin-mode.event-ws
  (:require-macros [cljs.core.async.macros :refer [go go-loop]])
  (:require
    [cljs.core.async :as async :refer [<! chan mult put! tap timeout untap]]
    [clojure.string :as str]
    [goog.json :as json]
    [teamoesterreich.admin-mode.data.backend :as backend]
    [teamoesterreich.util.log :as log :include-macros true]
    [teamoesterreich.util.ws :as ws]
    [teamoesterreich.view-state :as store]))


(def ws-url
  (if (or (str/starts-with? backend/WS_URL "ws:")
          (str/starts-with? backend/WS_URL "wss:"))
    backend/WS_URL
    (if (or (= "https:" (.-protocol js/location))
            (= 444 (.-port js/location)))
      (str "wss://" (.-hostname js/location) ":" (.-port js/location) backend/WS_URL)
      (str "ws://" (.-hostname js/location) ":" (.-port js/location) backend/WS_URL))))


(let [<data-ch (chan)
      !failed-counter (atom 0)
      >ws-ctl-ch (chan)]

  (def <state-ch (chan))
  (def >ctl-ch (chan))
  (def >send-ch (chan))

  (def <data-mult (mult <data-ch))

  (defn notify [channel payload]
    (put! >send-ch (json/serialize (clj->js {
                                             :channel channel
                                             :payload payload}))))

  (defn start-event-listener [init-tx]
    (log/debug "start-event-listener " init-tx)
    (go-loop []
             (let [res (<! >ctl-ch)]
               (log/debug "Event-Service-Ext-Ctl" res)
               (case res
                 :off (do
                        (put! >ws-ctl-ch :off))))
             (recur))

    (ws/ws-loop ws-url
                <data-ch
                <state-ch
                >ws-ctl-ch
                >send-ch)



    ;(log/debug "store tx ===================>" (:tx (om/root-cursor store/app-state)))

    ; connection indicator loop
    (go-loop []
             (let [res (<! <state-ch)]
               (if (nil? res)
                 nil
                 (do
                   (if (= res :opened)
                     (do
                       (swap! store/app-state assoc :ws-connected true)
                       (reset! !failed-counter 0))
                     (do
                       (swap! store/app-state assoc :ws-connected false)
                       (swap! !failed-counter inc)
                       (log/debug "got not connected " (name res) " times:" @!failed-counter)
                       (when (> @!failed-counter 3)
                         (do
                           (log/debug "ws not working !! Error Message ! ")
                           (put! >ws-ctl-ch :off)           ;kill ws service
                           ))))

                   (recur)))))
    ))

; debug log
(let [<event-ch (chan)]
  (tap <data-mult <event-ch)
  (async/reduce (fn [_ e]
                  (log/out "debug channel" e)
                  ) {} <event-ch))

;(put! >ctl-ch :off) ;kill service

;get initial state



(defn tap-update-listener [<event-ch callback-fn]
  (let [update (fn [_ e]
                 (try
                   (let [event (js->clj (json/parse (.-data e)))]
                     (when (= (get event "channel") "update")
                       (let [entity (get-in event ["payload" "entity"])
                             entity-uuid (get-in event ["payload" "uuid"])]
                         (log/debug "entity update called for: " entity " -> " entity-uuid)
                         (callback-fn entity entity-uuid)
                         )))
                   (catch :default e (str "Caught: " e))))]
    (tap <data-mult <event-ch)
    (async/reduce update {} <event-ch)))

(defn untap-update-listener [<event-ch]
  (untap <data-mult <event-ch))
